import { Model } from "./Model";

export interface SponsorshipType extends Model {	
	duration: number;
	name: string;
	singlePerFixture: string;
}

export class SponsorshipType implements SponsorshipType {

	constructor(data?: Partial<SponsorshipType>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}